import { globalLoading } from "../services/loading";
import { closeGlobalPopup, globalPopup } from "../services/popup";
import * as desafioService from "../services/desafio";

export function invitationAvailable(invitationMessageData, stompClient) {
  const principal = setInterval(() => {
    if (
      !window.GLOBALS.isInMultiplayer &&
      !window.GLOBALS.openInvitation &&
      !window.GLOBALS.searchingUser &&
      invitationMessageData.challengerId !== window.GLOBALS.user.info.user_id
    ) {
      window.GLOBALS = JSON.parse(localStorage.getItem("GLOBALS"));
      window.GLOBALS.openInvitation = true;
      localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
      invitationMessageData.challengeAccepted = false;

      let timeLeft = 10;
      let delay = 1000;

      const intervalo = setInterval(() => {
        if (timeLeft > 0 && !window.GLOBALS.searchingUser) {
          globalPopup(
            "Novo Desafio",
            true,
            [
              {
                texto: "Não",
                acao: () => {
                  closeGlobalPopup();
                  clearInterval(intervalo);

                  window.GLOBALS.isInMultiplayer = false;
                  window.GLOBALS.openInvitation = false;
                  localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));

                  stompClient.publish({
                    destination: "/app/challenge-response",
                    body: JSON.stringify(invitationMessageData),
                  });
                },
              },
              {
                texto: "Sim",
                acao: () => {
                  closeGlobalPopup();
                  clearInterval(intervalo);

                  // Coloca os dados do usuário
                  invitationMessageData.challengeAccepted = true;
                  invitationMessageData.userId = window.GLOBALS.user.info.id;
                  invitationMessageData.name = window.GLOBALS.user.info.nome;
                  invitationMessageData.picture =
                    window.GLOBALS.user.info.image;
                  invitationMessageData.uf = window.GLOBALS.user.info.uf;
                  invitationMessageData.opponentMatchPoints =
                    window.GLOBALS.user.info.qtdPontos;

                  window.GLOBALS.isInMultiplayer = true;
                  window.GLOBALS.openInvitation = false;
                  localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));

                  globalLoading(
                    "A sua partida vai começar em alguns segundos..."
                  );

                  stompClient.publish({
                    destination: "/app/challenge-response",
                    body: JSON.stringify(invitationMessageData),
                  });
                },
              },
            ],
            '<div class="popup-oponent-challange">Você está sendo desafiado no tema ' +
              "<strong>" +
              decodeURIComponent(invitationMessageData.themeName) +
              "</strong>" +
              " por:" +
              '<img class="adversario-panel-img" src="' +
              desafioService.checkImg(invitationMessageData.picture) +
              '" />' +
              '<h3 class="adversario-panel-name">' +
              decodeURIComponent(invitationMessageData.challengerName) +
              " - " +
              invitationMessageData.uf +
              "</h3>" +
              "<br />Vamos jogar?<br /><br />" +
              "<p style='text-align: center;'>Convite expira em " +
              timeLeft +
              "s</p>" +
              "</div>"
          );

          timeLeft--;
        } else {
          closeGlobalPopup();
          clearInterval(intervalo);
          window.GLOBALS.isInMultiplayer = false;
          window.GLOBALS.openInvitation = false;
          localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
        }
      }, delay);
    }
    clearInterval(principal);
    localStorage.setItem("GLOBALS", JSON.stringify(window.GLOBALS));
  }, 1000);
}
